module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Ukelele.a901ad1f.png";